import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecordatorioService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getRecordatorios(filter:any){
    return this.http.get(`${this.baserApiUrl}recordatorio?${filter}`,)
  }

  agregarRecordatorio(data:any){
    return this.http.post(`${this.baserApiUrl}recordatorio`,data)
  }
}